import axios from 'axios'
import AuthService from "./AuthService";

export default {
    accessToken() {
        return AuthService.getToken();
    },

    locale() {
        const userLang = navigator.language || navigator.userLanguage;
        return userLang.substring(0,2);
    },

    header() {
        return {
            baseURL: '/api/v2',
            headers: {
                'Authorization': 'Bearer ' + this.accessToken(),
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'App-Version': 3.0,
                'Content-Language' : this.locale()
            }
        };
    },

    fileHeader(){
        return {
            baseURL: '/api/v2',
            responseType: 'blob',
            headers: {
                'Authorization': 'Bearer ' + this.accessToken(),
                'Content-Language' : this.locale(),
                'App-Version': 3.0,
            }
        };
    },
    get(url){
        return axios.get(url, this.header()).then((result) => {
            return result.data;
        }).catch((error) => {
            if (error.response.status === 401) {
                const url = window.location.hash.substring(1);
                window.location.href = '/logout?redirect_url=' + url;
            }
            throw error;
        });
    },
    post(url, data){
        return axios.post(url, data, this.header()).then((result) => {
            return result;
        }).catch((error) => {
            if (error.response.status === 401) {
                window.location.href = '/logout';
            }
            throw error;
        });
    },
    put(url, data){
        return axios.put(url, data, this.header()).then((result) => {
            return result.data;
        }).catch((error) => {
            if (error.response.status === 401) {
                window.location.href = '/logout';
            }
            throw error;
        });
    },
    delete(url){
        return axios.delete(url, this.header()).then((result) => {
            return result.data;
        }).catch((error) => {
            if (error.response.status === 401) {
                window.location.href = '/logout';
            }
            throw error;
        });
    },
    downloadFile(url) {
        return axios.get(url, this.fileHeader()).then((result) => {
            return result;
        }).catch((error) => {
            if (error.response.status === 401) {
                window.location.href = '/logout';
            }
            throw error;
        });
    }
}